'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { relatoriosStore } from '@/infrastructure/store/relatoriosStore';

export function useRelatorios() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      evolucao: s.evolucao,
      loading: s.loading,
      failed: s.failed,
      erro: s.erro,
      inicio: s.inicio,
      fim: s.fim,
      loadEvolucao: s.loadEvolucao,
      aplicarPeriodo: s.aplicarPeriodo,
      limparPeriodo: s.limparPeriodo,
    })),
  );
}

/** Pure selector: the tab panel owns the load effect, each report with its own pair. */
export function useIndicadores() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      indicadores: s.indicadores,
      loading: s.indicadoresLoading,
      failed: s.indicadoresFailed,
      erro: s.indicadoresErro,
      inicio: s.indicadoresInicio,
      fim: s.indicadoresFim,
      load: s.loadIndicadores,
      recarregar: s.recarregarIndicadores,
      aplicarPeriodo: s.aplicarPeriodoIndicadores,
      limparPeriodo: s.limparPeriodoIndicadores,
    })),
  );
}

/** Pure selector: the tab panel owns the load effect, each report with its own pair. */
export function useMudancasCarteira() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      mudancas: s.mudancas,
      loading: s.mudancasLoading,
      failed: s.mudancasFailed,
      erro: s.mudancasErro,
      load: s.loadMudancas,
      recarregar: s.recarregarMudancas,
    })),
  );
}

export function useCargaCapacidade() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      carga: s.carga,
      loading: s.cargaLoading,
      failed: s.cargaFailed,
      erro: s.cargaErro,
      load: s.loadCarga,
      recarregar: s.recarregarCarga,
    })),
  );
}

export function useConfiabilidadePrazo() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      confiabilidade: s.confiabilidade,
      loading: s.confiabilidadeLoading,
      failed: s.confiabilidadeFailed,
      erro: s.confiabilidadeErro,
      load: s.loadConfiabilidade,
      recarregar: s.recarregarConfiabilidade,
    })),
  );
}

/**
 * Pessoas por celula: um seletor puro, como os outros daqui. Carrega uma vez por sessao
 * e a tela chama `recarregar` no botao do estado de erro.
 */
export function usePessoasPorCelula() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      pessoas: s.pessoas,
      loading: s.pessoasLoading,
      failed: s.pessoasFailed,
      load: s.loadPessoas,
      recarregar: s.recarregarPessoas,
    })),
  );
}

export function useParqueDeMaquinas() {
  return useStore(
    relatoriosStore,
    useShallow((s) => ({
      parque: s.parque,
      loading: s.parqueLoading,
      failed: s.parqueFailed,
      load: s.loadParque,
      recarregar: s.recarregarParque,
    })),
  );
}
